import zhCN from './zh-CN';
export * from './type';
export var defaultLocale = zhCN;
